import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { validateOtpResetPasswordActions } from "redux/actions/auth/ResetPassword/validateOtpResetPasswordActions";
import { RootState } from "~/redux/rootReducer";
import { useTranslation } from "react-i18next";

interface validateOtpTypes {
  otp: string;
}

export const useValidateOtpFormik = (
  setResetPop: any,
  resetPasswordMethod: any,
  phoneNum: any,
  email: any
) => {
  const dispatch: any = useDispatch();
  const { t, i18n } = useTranslation();

  const { otpToken } = useSelector(
    (state: RootState) => state.generateOtpResetPassword
  );

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: yup.object({
      otp: yup.string().required(`${t("This field is required")}`),
    }),
    onSubmit: async (values: validateOtpTypes) => {
      await dispatch(
        validateOtpResetPasswordActions(
          {
            screen: "otp_validation", //static value
            token: otpToken, // token value
            otp_code: values.otp, // OTP value
            device: "web", // static
          },
          () => {
            setResetPop("resetPassword");
          }
        )
      );
    },
  });

  return formik;
};
